$(document).ready(function () {
    // product tab js
    $('ul.tabs li').on('click', function () {
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');
        $(this).addClass('current');
        $('#' + tab_id).addClass('current');
    });

    let selectedProducts = [];
    let count = 0;
    function disableButton(count) {
        //console.log('count ===', count);
        $('.product-add-btn .quantity-plus').attr('disabled', count > 2);
        $('.pro_common').toggleClass('hide_no_selectedpro', count === 0);
        
        const maxCount = 3;
        const lessPro = maxCount - count;
        $('.less_pro').text(lessPro);
        
        // Update progress bar width
        const progressPercent = (count / maxCount) * 100;
        $('.progress-bar.progress-bar-danger').css('width', progressPercent + '%');
    }
    
    function updateSummary(selectedProducts){        
        let totalPrice = 0;
        selectedProducts.forEach(function(product, index) {
            totalPrice += parseFloat(product.price);
        });
        $('.product-totalPrice').text('$'+totalPrice/100);
        $('.product-add-btn button').toggleClass('disable', totalPrice === 0);
    }

    function updateQuantityDisplay($btn, newVal) {
        //console.log('newVal ===', newVal);
        $btn.find('input').val(newVal);
        $btn.find('.select-quantity-input-display').text(newVal);
        $btn.toggleClass('no-quantity', newVal === 0);
    }

    function addProductToSummary(proId, name, image, price) {
        const html = `
            <div class="product-right-add pro-${proId}">
                <div class="product-show-deta">
                    <img src="${image}" alt="${name}">
                    <button type="button" data-proId="${proId}" class="remove-pro">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="9.5" fill="#F7F8F9" stroke="black"></circle>
                            <rect x="12.6665" y="6" width="1.8856" height="9.42801" transform="rotate(45 12.6665 6)" fill="black"></rect>
                            <rect x="14" y="12.6665" width="1.8856" height="9.42801" transform="rotate(135 14 12.6665)" fill="black"></rect>
                        </svg>
                    </button>
                </div>
                <div class="product-show-content">
                    <h5>${name}</h5>
                </div>
            </div>`;
        $('.product-right-show').prepend(html);
        $('.product-add-btn .bundle-form').prepend(`<input type="hidden" name="id[]" value="${proId}">`);
        selectedProducts.push({ id: proId, title: name, image, price });
    }
    function removeProductFromSummary(proId) {
        const index = selectedProducts.findIndex(product => product.id === proId);
        if (index !== -1) {
            selectedProducts.splice(index, 1);
        }
        $(`.product-add-btn .bundle-form input[type="hidden"][value="${proId}"]`).first().remove();
        $(`.product-right-add.pro-${proId}`).first().remove();
    }    


    function resetSelected(){
         // Reset selected products and count
        selectedProducts = [];
        count = 0;

        // Reset all quantity inputs and displays
        $('.product-add-btn').each(function () {
            $(this).find('input').val(0);
            $(this).find('.select-quantity-input-display').text(0);
            $(this).addClass('no-quantity');
        });

        // Remove all selected product previews
        $('.product-right-add[class*="pro-"]').remove();

        // Remove all hidden inputs from form
        $('.bundle-form input[type="hidden"]').remove();

        // Reset total price
        $('.product-totalPrice').text('$0.00');

        // Reset "Add 1 more..." text
        $('.less_pro').text('3');

        // Reset progress bar
        $('.bundle-progress-bar .progress-fill').css('width', '0%');

        // Re-disable buttons as needed
        disableButton(count);
    }

    $('body').on('click', '.product-add-btn .quantity', function () {
        const $btn = $(this).closest('.product-add-btn');
        const proId = $btn.data('proid');
        const proPrice = $btn.data('proprice');
        const name = $btn.data('name');
        const image = $btn.data('image');
        const $input = $btn.find('input');
        let quantity = parseInt($input.val()) || 0;

        if ($(this).hasClass('quantity-plus')) {
            if (count >= 3) return; // prevent adding more than 3
            quantity++;
            count++;
            addProductToSummary(proId, name, image, proPrice);
        } else {
            if (quantity > 0) {
                quantity--;
                count--;
                removeProductFromSummary(proId);
            }
        }

        updateQuantityDisplay($btn, quantity);
        updateSummary(selectedProducts);
        disableButton(count);
    });

    
    $('body').on('submit', '.bundle-form', function (e) {
        e.preventDefault();
        var form = $(this);
        $('.bundle-submit-button').attr('disabled');
        $('.bundle-submit-button span').text('Adding.....');
        const bundleId = 'bundle-' + Date.now();
        const serializedData = form.serializeArray();
        serializedData.push({ name: 'properties[bundle_id]', value: bundleId });
        $.ajax({
          url: '/cart/add.js',
          data: $.param(serializedData),
          type: 'POST',
          dataType: 'json',
          async:false,
          success: function(){
            alert('Bundle Form submit Successfully'); 
                       
            // Re-enable submit button
            $('.bundle-submit-button').removeAttr('disabled');
            $('.bundle-submit-button span').text('Add to Cart');
            
            resetSelected();
          }
        });
    })

    $('body').on('click', '.remove-pro', function () {
        const proId = $(this).data('proid');
        const $btn = $(`.product-add-btn[data-proid="${proId}"]`);
        const $input = $btn.find('input');
        let quantity = parseInt($input.val()) || 0;

        if (quantity > 0) {
            quantity--;
            count--;
            removeProductFromSummary(proId);
        }

        updateQuantityDisplay($btn, quantity);
        updateSummary(selectedProducts);
        disableButton(count);
    });

    

    


});